import { useEffect, useState, useRef } from "react";
import { v4 as uuid } from "uuid";

import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { getHospitalWards } from "@/services/sintegrada/departments/getHospitalWards";
import { Option } from "@/@types/generics/Option";
import { HospitalWard } from "@/@types/sintegrada/HospitalWard";

import { SelectComponent, SelectComponentProps } from "@/components/SelectComponent";

type Props = SelectComponentProps & {
	departmentId: number;
};

export const defaultHospitalWardSelectOption = {
	label: "Todas as alas",
	value: {} as HospitalWard,
};

export function HospitalWardSelect({ departmentId, ...rest }: Props) {
	const { uf, ibgeCode, cnes } = useCurrentAccount();

	const isFirstRender = useRef(true);

	const [key, setKey] = useState(uuid());
	const [options, setOptions] = useState<Option<HospitalWard>[]>([]);

	async function fetchData() {
		const data = await getHospitalWards({
			uf,
			ibgeCode,
			cnes,
			departmentId,
		});

		const transformedData = data.map((hospitalWard) => ({
			value: hospitalWard,
			label: hospitalWard.name,
		}));

		setOptions([defaultHospitalWardSelectOption, ...transformedData]);

		setKey(uuid());
	}

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;

			return;
		}

		fetchData();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [departmentId]);

	return (
		<SelectComponent
			key={key}
			inputId="hospital-wards"
			placeholder="Selecione..."
			noOptionsMessage={() => "Sem opções"}
			options={options}
			{...rest}
		/>
	);
}
